import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { ButtonProps } from '@mui/material/Button';

interface LoadingButtonProps {
  id?: string;
  loading: boolean;
  children: React.ReactNode;
  type?: ButtonProps['type'];
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  color?: ButtonProps['color'];
  disabled?: boolean;
  onClick?: ButtonProps['onClick'];
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
  form?: string;
  style?: React.CSSProperties;
  autoFocus?: boolean;
  sx?: any;
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  id,
  loading = false,
  children,
  type,
  variant = 'contained',
  size = 'medium',
  color,
  disabled,
  onClick,
  startIcon,
  endIcon,
  fullWidth,
  className,
  form,
  style,
  autoFocus,
  sx,
}: LoadingButtonProps) => (
  <Button
    id={id}
    type={type}
    variant={variant}
    size={size}
    color={color}
    disabled={loading || disabled}
    onClick={onClick}
    startIcon={loading ? <CircularProgress color="inherit" size={20} /> : startIcon}
    endIcon={endIcon}
    fullWidth={fullWidth}
    className={className}
    form={form}
    style={style}
    autoFocus={autoFocus}
    sx={sx}
  >
    {children}
  </Button>
);

export default LoadingButton;
